/* 布局 */
//前台
import Layout from "@views/layout";

const raffleprizesRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "raffleprizes",
            name: "RAFFLEPRIZES",
            meta: {
                title: "奖品库管理",
                sort: 1,
            },
            component: () => import("@views/business/raffleprizes/index.vue"),
            redirect: {
                name: "RAFFLEPRIZES_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "RAFFLEPRIZES_LIST",
                    meta: {
                        title: "奖品库管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/raffleprizes/list.vue"),
                },
                                {
                    path: "add",
                    name: "RAFFLEPRIZES_ADD",
                    meta: {
                        title: "新增抽奖奖品表",
                        parentPath: '/business/raffleprizes/list',
                        operate: true,
                    },
                    component: () => import("@views/business/raffleprizes/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "RAFFLEPRIZES_EDIT",
                    meta: {
                        title: "编辑抽奖奖品表",
                        parentPath: '/business/raffleprizes/list',
                        operate: true,
                    },
                    component: () => import("@views/business/raffleprizes/form.vue"),
                },
                                        ],
    },


        ],
};

export default raffleprizesRouter;
